<template>
  <div>
    <el-row>
      <el-table stripe
                border
                height="350"
                :data="tableData"
                ref="employeeTable"
                style="width: 100%">
        <el-table-column :label="this.$t('employee.employeeNo')"
                         prop="employeeNo"></el-table-column>
        <el-table-column :label="this.$t('employee.formattedName')"
                         prop="formattedName"></el-table-column>
        <el-table-column :label="this.$t('employee.email')"
                         prop="email"></el-table-column>
        <el-table-column :label="this.$t('employee.phone')"
                         prop="phone"></el-table-column>
      </el-table>
    </el-row>

    <el-row>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: left;">
          <el-pagination @size-change="changePageSize"
                         @current-change="changePage"
                         :current-page="curPage"
                         :page-size="pageSize"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total"></el-pagination>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import * as dashboardApi from '@/services/enterpriseDashboardApi.js'
export default {
  data () {
    return {
      total: 0,
      tableData: []
    }
  },

  props: {
    dataType: {
      type: String,
      default: ''
    },
    condition: {
      type: Number,
      default: 7
    },
    curPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  mounted () {
    // this.pager = {
    //   curPage: 1,
    //   pageSize: 10
    // }
    this.tableData = []
    this.commQuery()
  },
  watch: {
    dataType () {
      this.tableData = []
      this.commQuery()
    },
    condition () {
      this.tableData = []
      this.commQuery()
    }
  },
  methods: {
    changePage (current) {
      this.curPage = current
      this.commQuery()
    },
    changePageSize (pageSize) {
      this.pageSize = pageSize
      this.commQuery()
    },
    commQuery () {
      let params = {
        active: this.dataType === 'newAdde' ? 1 : 0,
        condition: this.condition
      }
      dashboardApi
        .employeeUpdateTotalDetails({
          params: params,
          pager: {
            total: this.total,
            curPage: this.curPage,
            pageSize: this.pageSize
          }
        })
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            this.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.curPage =
              data.payload.results.curPage || data.payload.curPage
            this.total =
              data.payload.results.totalRecords || data.payload.totalRecords
            this.pageSize =
              data.payload.results.pageSize || data.payload.pageSize
          }
        })
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/modules/comComponent/employeeDetail.vue